var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"label":_vm.inputLabel,"placeholder":_vm.inputPlaceholder,"selectOptions":{
      options: _vm.listDBs,
      getOptionLabel : option => option.title,
      reduce : dbConfig => dbConfig.title
    },"value":_vm.input,"labelAsColumn":_vm.labelAsColumn,"required":_vm.required,"rowClass":_vm.rowClass},on:{"update:value":function($event){_vm.input=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }